import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { routerPropTypes } from 'Types'
import { withRouter } from 'react-router'
import { MoreFilterButton, MobileViews } from './components'
import { StoreProductsResponse } from '../../components'
import skins from './skins'
import { skin, UrlBuilder } from 'Utils'
import { Icon, ResultsButton, ItemsFound } from 'Blocks'

class MobileFilters extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.any,
    ...routerPropTypes,
    loading: PropTypes.any,
    location: PropTypes.any,
    match: PropTypes.any,
    queryString: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.handleNavigation = this.handleNavigation.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.generateTitle = this.generateTitle.bind(this)
  }

  handleNavigation(destination) {
    const builder = new UrlBuilder(this.props.queryString)
    this.props.history.push(builder.setDialogView(destination).getQueryString())
  }

  handleClose() {
    this.handleNavigation(false)
  }

  generateTitle(view) {
    switch (view) {
      case 'Colour': {
        return 'Colour'
      }
      case 'Department': {
        return 'Department'
      }
      case 'SortBy': {
        return 'Sort By'
      }
      case 'Price': {
        return 'Price'
      }
      case 'Stores': {
        return 'Stores'
      }
      default: {
        return 'Filter & Sort'
      }
    }
  }

  render() {
    const view = this.props.queryString.match(/dialogView=(\w+)/)[1]

    const mobileViewsProps = {
      loading: this.props.loading,
      queryString: this.props.queryString,
      data: this.props.data,
      match: this.props.match,
      view
    }

    return (
      <div className={this.props.className}>
        <div className="dialog-view">
          {this.props.data && (
            <StoreProductsResponse
              data={this.props.data}
              location={this.props.location}
            />
          )}
          <div className="filter-panel__header">
            <h2 className="filter-panel__title">{this.generateTitle(view)}</h2>
            <span className="close-modal__wrapper">
              <Icon
                className="close-modal"
                name="close"
                onClick={() => this.handleClose()}
              />
            </span>
          </div>
          <ItemsFound loading={this.props.loading} />
          <MobileViews {...mobileViewsProps} />
          <div className="filter-panel__actions">
            {view !== 'Refine' && (
              <MoreFilterButton
                title={this.generateTitle(view)}
                handleClick={this.handleNavigation}
              />
            )}
            <ResultsButton
              handleClick={this.handleClose}
              queryString={this.props.queryString}
              className="panel-buttons__apply"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(skin(MobileFilters, skins))
